/**
 * The four payment states the API accepts, with the words the business uses — shared by
 * the payment card (`LifecyclePanels.PaymentPanel`) and the CRF record's Commercials row,
 * which since Train E (fork 15) sit on the SAME screen and must print the SAME word for
 * the same fact ("Free of charge", not "foc").
 *
 * Its own module rather than an export from `LifecyclePanels.tsx` only because that file
 * is components, and a constant exported beside a component trips
 * `react-refresh/only-export-components` — a warning this app carries nineteen times
 * already and did not need a twentieth of.
 *
 * `Record<PaymentStatus, string>` — exhaustive on purpose. Adding a state to the API's
 * union breaks this build until somebody writes its label, which is the point: a status
 * rendered as a raw enum value is one nobody can act on.
 */

import type { PaymentStatus } from './api';

export const PAYMENT_LABEL: Readonly<Record<PaymentStatus, string>> = {
  advance: 'Advance received',
  pending: 'Pending',
  received: 'Received',
  foc: 'Free of charge',
};

/** The order the card offers them in — the business's reading order, not the enum's. */
export const PAYMENT_ORDER: readonly PaymentStatus[] = ['pending', 'advance', 'received', 'foc'];
